// extracted by mini-css-extract-plugin
export default {"main":"App_main__-kK8X","output":"App_output__6Y9Fl","numpad":"App_numpad__5j9Zo","history":"App_history__S2ntP"};